<template>
  <div class="comment-container">
    <h5 class="color-main">Do you have any comments?</h5>
    <form class="form-comments">
      <input
        class="form-comments_input"
        v-model="userEmail"
        placeholder="Email"
        type="email"
        readonly
        disabled
      />
      <textarea
        class="form-comments_area"
        v-model="message"
        placeholder="Comments"
        cols="30"
        rows="10"
      ></textarea>
      <button
        :disabled="!isEnable"
        class="atm-button w-50 m-auto bg-main"
        @click.prevent="submitFormController"
        type="submit"
      >
        Send
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    userEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      message: ''
    };
  },
  computed: {
    isEnable() {
      return this.message && this.userEmail;
    }
  },
  methods: {
    clearForm() {
      this.message = '';
    },
    submitFormController() {
      this.$emit('onSubmitCommentForm', {
        message: this.message,
        userEmail: this.userEmail,
      });
    }
  }
};
</script>

<style lang="scss">
.comment-container {
  .form-comments {
    display: grid;
    gap: 1rem;

    &_input,
    &_area {
      background: #f3f3f3;
      border-radius: 8px;
      padding: 0.7rem;
      border: none;
      outline: none;
    }
  }
}
</style>
